import api from './api'

export const emailCampaignService = {
  getAllCampaigns: async () => {
    const response = await api.get('/email-campaigns')
    return response.data
  },

  getCampaignById: async (id) => {
    const response = await api.get(`/email-campaigns/${id}`)
    return response.data
  },

  createCampaign: async (data) => {
    const response = await api.post('/email-campaigns', data)
    return response.data
  },

  updateCampaign: async (id, data) => {
    const response = await api.put(`/email-campaigns/${id}`, data)
    return response.data
  },

  deleteCampaign: async (id) => {
    const response = await api.delete(`/email-campaigns/${id}`)
    return response.data
  },

  sendNow: async (id) => {
    const response = await api.post(`/email-campaigns/${id}/send-now`)
    return response.data
  },

  cancelCampaign: async (id) => {
    const response = await api.post(`/email-campaigns/${id}/cancel`)
    return response.data
  },

  getSummary: async (id) => {
    const response = await api.get(`/email-campaigns/${id}/analytics/summary`)
    return response.data
  },

  getTimeseries: async (id) => {
    const response = await api.get(`/email-campaigns/${id}/analytics/timeseries`)
    return response.data
  },

  getLinks: async (id) => {
    const response = await api.get(`/email-campaigns/${id}/analytics/links`)
    return response.data
  },

  getRecipients: async (id, params = {}) => {
    const response = await api.get(`/email-campaigns/${id}/analytics/recipients`, { params })
    return response.data
  },

  getDevices: async (id) => {
    const response = await api.get(`/email-campaigns/${id}/analytics/devices`)
    return response.data
  },

  getProviders: async (id) => {
    const response = await api.get(`/email-campaigns/${id}/analytics/providers`)
    return response.data
  }
}
